/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idRoletaCheckin: string;
  idCorretorSistemaOrigem: string;
}

export function useRemoverUsuario() {
  const postData = async (props: Props) => {
    const INICIAR_INSCRICAO = `${leadsWebEnviroment}/common/checkin/recepcao/remover/v1`;
    const response = await instance.delete(INICIAR_INSCRICAO, {
      data: {
        idRoletaCheckin: props.idRoletaCheckin,
        idCorretorSistemaOrigem: props.idCorretorSistemaOrigem,
      },
    });
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: postData,
    onSuccess: () => { },
    onError: () => { },
  });

  return mutation;
}
